module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.9.1 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 isVisible 获取当前显示状态 #2704")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 isVisible 获取当前显示状态 #2704")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/loading.html"
    }
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 isVisible 获取当前显示状态 #2704")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复使用类 scroll 组件时会被覆盖的问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修正弹出框右边有黑边 #2651")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/qrcode.html"
    }
  }, [_vm._v("Qrcode")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复中文支持 #2652")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复全局 box-sizing 为 border-box 时导致的高度问题 #2621。感谢 @suncodeer ")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 isVisible 获取当前显示状态 #2704")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-circle.html"
    }
  }, [_vm._v("XCircle")])]), _vm._v(" "), _c('ul')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3dd7730c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3dd7730c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.9.1-269.vue
// module id = 2172
// module chunks = 226